import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {compose} from 'redux';
import './AppointmentServicesCard.css';
import TiresExchange from './TiresExchange';
import TiresReplacement from './TiresReplacement';
import ValueServicesCart from './ValueServicesCart';
import Card from '../../common/Card';
import Checkbox from '../../../public/journey1/fragments/services/Checkbox';
import InterventionService from '../../../services/Intervention';
import Constants from '../../../services/Constants';

class AppointmentServicesCard extends React.Component {

  static propTypes = {
    dispatchFetchServices: PropTypes.func.isRequired,
    dispatchUpdateServices: PropTypes.func.isRequired,
    intervention: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      pristine: true
    }
  }

  componentDidMount() {
    const {journey: {properties = {}} = {}} = this.props.intervention;
    if (properties.services) {
      const {services: {services, tiresExchange, tiresReplacement}} = properties;
      this.setState({requestedServices: services, tiresExchange, tiresReplacement})
    }
    this.props.dispatchFetchServices();
  }

  onServicesSave = () => {
    const {intervention: {journey: {id, properties}, origin}} = this.props;
    const {requestedServices, tiresExchange, tiresReplacement} = this.state;

    const oas = origin === 'OAS';

    let body = {type: Constants.TYPE_APPOINTMENT.value, services: requestedServices.map(r => oas ? r.id : r.name)};
    if (body.services.includes("tiresExchange")) {
      body.tiresExchange = tiresExchange;
    }
    if (body.services.includes("tiresReplacement")) {
      body.tiresReplacement = tiresReplacement;
    }
    if (properties.services.valueServicesCart) {
      body.bookingToken = properties.services.valueServicesCart.bookingToken;
    }
    this.props.dispatchUpdateServices(id, body);
  };

  onServicesChange = (e, service) => {
    const {target: {checked}} = e;
    let {requestedServices} = this.state;
    requestedServices = requestedServices.filter(e => e.name !== service.name);

    if (checked) {
      requestedServices.push(service);
    }
    this.setState({requestedServices, pristine: false});
  };

  onTiresExchangeChange = (tiresExchange, pristine = false) => {
    this.setState({tiresExchange, pristine});
  };

  onTiresReplacementChange = (tiresReplacement, pristine = false) => {
    this.setState({tiresReplacement, pristine});
  };

  filterService(journey, service) {
    if (Constants.TYPE_APPOINTMENT.value === journey.type) {
      return true;
    }
    if (Constants.TYPE_BODYWORK.value === journey.type) {
      return service.category === Constants.BODYWORK_SERVICE.value
    }
    return false;
  }

  collectExtraServices(journey, services, collector) {
    services
      .filter(service => this.filterService(journey, service))
      .forEach(service => collector.push(service))
  }

  collectServices(journey, services, selector, requestedServiceNames, collector) {
    (selector === 'id' ? Object.values(services).sort((a, b) => a.order - b.order) : Object.values(services))
      .filter(service => service.active || requestedServiceNames.includes(service[selector]))
      .filter(service => this.filterService(journey, service))
      .forEach(service => collector.push(service));
  }

  render() {
    const {requestedServices = [], tiresExchange = {}, tiresReplacement = {}, pristine} = this.state;
    const {intl, intl: {formatMessage}, intervention, intervention: {journey}, fetchServices, updateJourneyServices: {error = {}}, connectedUserId, canWrite} = this.props;
    const {mainServices = {}, myBMWAppServices = {}, otherServices = {}, additionalServices = {}, extraServices = [], myBMWAppExtraServices = []} = fetchServices.services;
    const {properties: {services = {}}} = journey;
    const errors = error.content || {};
    const oas = InterventionService.isOAS(intervention);
    const requestedServiceNames = requestedServices.map(s => oas ? s.id : s.name);
    
    const availableMainServices = [];
    const availableAdditionalServices = [];

    if (oas) {
      this.collectServices(journey, myBMWAppServices, 'id', requestedServiceNames, availableMainServices);
      this.collectExtraServices(journey, myBMWAppExtraServices, availableAdditionalServices);
    } else {
      this.collectServices(journey, mainServices, 'name', requestedServiceNames, availableMainServices);
      this.collectServices(journey, otherServices, 'name', requestedServiceNames, availableMainServices);
      this.collectServices(journey, additionalServices, 'name', requestedServiceNames, availableAdditionalServices);
      this.collectExtraServices(journey, extraServices, availableAdditionalServices);
    }

    const canAddServices = canWrite && !InterventionService.isComplete(intervention);
    return (
      <Card
        title={formatMessage({id: 'appointment.detail.services.title'})}
        pristine={!pristine}
        button={canAddServices &&
          <button onClick={this.onServicesSave} disabled={pristine} type="primary" className={`btn btn-sm btn-primary`}>
            {formatMessage({id: 'action.save'})}
          </button>
        }
      >

        <div className="box__body">
          {errors && errors.services &&
            <div className="alert alert--error">
              {formatMessage({id: errors.services.message})}
            </div>
          }

          <div className="row">
            {services.valueServicesCart && <div className="col-md-6 col-xxl-6">
              <ValueServicesCart cart={services.valueServicesCart}/>
            </div>}
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.services.requested-services.title'})}</h3>

              <ul className="list">
                {availableMainServices.map((s, index) =>
                  <li key={index}>
                    <Checkbox id={s.name} checked={requestedServiceNames.includes(oas ? s.id : s.name)} disabled={!canAddServices} onChange={(checked, e) => this.onServicesChange(e, s)}>
                      {formatMessage({id: `services.${s.name}`})}
                    </Checkbox>
                    {!s.active && <div className={"txt-error"}>{formatMessage({id: 'appointment.detail.services.deprecated'})}</div>}
                  </li>
                )}
              </ul>
            </div>
            <div className="col-md-6 col-xxl-6">
              <h3 className="box__subtitle">{formatMessage({id: 'appointment.detail.services.additional-services.title'})}</h3>
              <ul className="list">
                {availableAdditionalServices.map((s, index) => {
                  const name = s.mlItem ? s.mlItem[intl.locale] : formatMessage({id: `services.${s.name}`});
                  return (<li key={index}>
                    <Checkbox id={oas ? s.id : s.name} checked={requestedServiceNames.includes(oas ? s.id : s.name)} disabled={!canAddServices} onChange={(checked, e) => this.onServicesChange(e, s)}>{name}</Checkbox>
                    {!s.active && <div className={"txt-error"}>{formatMessage({id: 'appointment.detail.services.deprecated'})}</div>}
                  </li>)
                })}
              </ul>

            </div>
          </div>
          {requestedServiceNames.includes("tiresReplacement") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresReplacement uuid={journey.uuid} canWrite={canAddServices} connectedUserId={connectedUserId}
                                  errors={errors} tiresReplacement={tiresReplacement} onChange={this.onTiresReplacementChange}/>
              </div>
            </div>
          }
          {requestedServiceNames.includes("tiresExchange") &&
            <div className="row">
              <div className="col-md-12 col-xxl-12">
                <TiresExchange tiresExchange={tiresExchange} canWrite={canAddServices} onChange={this.onTiresExchangeChange} errors={errors}/>
              </div>
            </div>
          }
          {intervention.origin === Constants.ORIGIN_CALL_CENTER.value &&
            <div className="advisor-comment__field" style={{backgroundColor: '#fafafa', marginTop: '20px'}}>
              <p style={{color: '#262626', fontWeight: 'bold'}}><FormattedMessage id={'customer.journey.comment.title'}/></p>
              <p style={{fontStyle: 'italic', wordWrap: 'break-word'}}>{journey.comment}</p>
            </div>
          }
        </div>

      </Card>
    )
  }
}

const mapStateToProps = state => ({
  intervention: state.fetchIntervention.intervention,
  fetchServices: state.fetchServices,
  updateJourneyServices: state.updateJourneyServices
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchServices: (parameters, filters) => dispatch({type: 'FETCH_SERVICES.REQUEST', parameters, filters}),
  dispatchUpdateServices: (id, body) => dispatch({type: 'UPDATE_JOURNEY_SERVICES.REQUEST', id, body}),
});


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AppointmentServicesCard);
